import { Row, Col, Image, Form, Button } from "react-bootstrap";
import { useState } from "react";
import { ModalMessage } from "../generalLayout";

export default function OrderItem(props) {
  // displays an individual product (used on the order details page)
  const [showAlertMsg, setShowAlertMsg] = useState(false);

  if (!props.data) {
    return null;
  }


  const handleConfirm = () => {
    props?.deleteItem(props.data._id)
  }


  return (
    <>
      <Row className="mt-3">
        <Col xs={3} lg={2}>
          {/* could have property image (orders) or images array (cart) */}
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              fluid
              style={{ maxHeight: "200px", padding: "5px" }}
              src={props?.data?.image || props?.data?.images[0]?.url}
            />
          </div>
        </Col>
        <Col xs={5} lg={2}>
          <b>{props?.data?.name}</b> <br />
          <div style={{fontSize: "smaller", fontStyle: "italic", marginTop: "3px"}}>
          {props?.data?.category || props?.data?.categories[0]?.name}
          </div>
        </Col>
        <Col xs={4} lg={2}>{`Price per unit: $${props.data?.price}`}</Col>
        {props.readOnly ? (
          <Col md={5} className="text-end">
            {`Quantity: ${props.quantity}`}
          </Col>
        ) : (
          <>
            <Col xs={10} lg={3}>
              <Form.Select
                value={props?.quantity}
                style={
                  props.data?.inventoryCount < props?.quantity
                    ? { border: "2px solid red" }
                    : null
                }
                onChange={(event) =>
                  props?.updateQuantity(
                    props.data?._id,
                    Number(event.target.value)
                  )
                }
              >
                {/* quantity selection */}
                {props.data?.inventoryCount < 1 ? (
                  <option value={0}>Out of stock</option>
                ) : (
                  <>
                  {/* if requested quantity > available inventory, show requested quantity but put red box around it */}
                    {props.data?.inventoryCount < props?.quantity && (
                      <option value={0}>{props?.quantity}</option>
                    )}
                    {Array.from(
                      { length: props.data?.inventoryCount },
                      (_, idx) => (
                        <option key={idx + 1} value={idx + 1}>
                          {idx + 1}
                        </option>
                      )
                    )}
                  </>
                )}
              </Form.Select>
              {props.data?.inventoryCount > 0 &&
                props.data?.inventoryCount < props?.quantity && (
                  <p style={{ color: "red", fontSize: "small" }}>
                    Not enough inventory. Please choose a new quantity.
                  </p>
                )}
            </Col>
            <Col xs={2} lg={3}>
              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  setShowAlertMsg(true);
                }}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </Col>
          </>
        )}
      </Row>
      <br />
      {showAlertMsg && 
      <ModalMessage
          message="Are you sure you want to remove this item from your cart?"
          confirmButton={true}
          handleConfirm={handleConfirm}
          setShowAlertMsg={setShowAlertMsg}
        /> 
      }
    </>
  );
}
